import { render } from "./PracticeMultipleView.vue?vue&type=template&id=e0802a00&ts=true"
import script from "./PracticeMultipleView.vue?vue&type=script&lang=ts"
export * from "./PracticeMultipleView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__